import { useAuthStore } from '@/stores/authStore';

export const version = '0.1.1';
export const apiGatewayDomain = process.env.VUE_APP_KRAKEND_API_GATEWAY
export const krakendGatewayDomain = process.env.VUE_APP_KRAKEND_API_GATEWAY
export const sasCommissionDomain = process.env.VUE_APP_COMMISSION?? 'https://sas-demo-commission.fintos.com.my'
export const CTOS_TEST_MODE = process.env.VUE_APP_CTOS_TEST_MODE ?? 'true'
export const APP_MODE = process.env.VUE_APP_MODE ?? 'demo'
export const AES_KEY = process.env.VUE_APP_KEY_AES ?? 'null'
export const APP_CODE = process.env.VUE_APP_CODE
export const APP_VERSION = process.env.PACKAGE_VERSION
export const kycAPI = process.env.VUE_APP_KYC_API ?? 'https://kyc-api.fintos.com.my'; // Fix here
export const kycVUE = process.env.VUE_APP_KYC ?? 'https://kyc.fintos.com.my'; 
export const APACHE_SUPERSET = process.env.VUE_APP_APACHE_SUPERSET ?? 'https://apache-superset.imortgage2u.com'
export const FINTOS_SITE = process.env.VUE_APP_FINTOS_SITE ?? 'https://fintos.com.my'
export const LMS_SITE = process.env.VUE_APP_LMS_SITE ?? 'https://lms-demo.invinity.my'
export const CUSTOMER_FORM_SLUG = process.env.VUE_APP_CUSTOMER_FORM_SLUG ?? 'customer-from-demo'
export const SAS_SITE = process.env.VUE_APP_SAS_SITE ?? 'https://sas-v2.imortgage2u.com';
export const VPS_SITE = process.env.VUE_APP_VPS_SITE ?? 'https://vps-v2.imortgage2u.com';
export const DAHONGYE_SITE = process.env.VUE_APP_DAHONGYE_SITE ?? 'https://dahongye.imortgage2u.com';
export const LNG_SITE = process.env.VUE_APP_LNG_SITE ?? 'https://lng.imortgage2u.com';
export const PKNS_SITE = process.env.VUE_APP_PKNS_SITE ?? 'https://pkns.imortgage2u.com';

export const services = {
	auth: apiGatewayDomain + '/auth/',
	access_control: apiGatewayDomain + '/srv-access-control/',
	attachment: apiGatewayDomain + '/srv-attachment/',
	customer: apiGatewayDomain + '/srv-customer/',
	financial_proposal: apiGatewayDomain + '/srv-financial-proposal/',
	lookup: apiGatewayDomain + '/srv-lookup/',
	hub: apiGatewayDomain + '/srv-hub/',
	lead: apiGatewayDomain + '/srv-lead/',
	commitment: apiGatewayDomain + '/srv-credit-report/',
	messaging: apiGatewayDomain + '/srv-message/',
	esign: apiGatewayDomain + '/srv-esign/',
	product: apiGatewayDomain + '/srv-product/',
	approval: apiGatewayDomain + '/srv-approval/',
	notification: apiGatewayDomain + '/srv-notification/',
	calculator: 'https://api-calculator.fintos.com.my/',
	calculatorNew: apiGatewayDomain,
	initial_proposal: apiGatewayDomain + '/srv-proposal/',
	fintos_calculator: 'https://api.imortgage2u.com/fintos/calculator/',
	billing: apiGatewayDomain + '/srv-billing/',
	commission: apiGatewayDomain + '/srv-commission/',
	invinity: apiGatewayDomain + '/srv-invinity/',
	hestia: apiGatewayDomain + '/srv-hestia/',
	kyc_api: kycAPI,
	kyc_vue: kycVUE,
	temp_mortgage_calc: krakendGatewayDomain
}

export const homeLink = process.env.VUE_APP_FRONTEND
export const fintosCustomerFormLink = FINTOS_SITE + '/' + CUSTOMER_FORM_SLUG
export const fileServer = krakendGatewayDomain


export const getHeader = function (refreshToken = false) {
	if(!refreshToken){
		const authStore = useAuthStore()
		authStore.refresh()
	}

	const tokenData = JSON.parse(window.localStorage.getItem('auth_token'))

	const headers = {
		'Accept': 'application/json',
		'Authorization': 'Bearer ' + tokenData?.access_token,
		'Application-Code': _gAuth.appCode(),
	}

	return headers
}

export const getKycHeader = function () {
	const tokenData = JSON.parse(window.localStorage.getItem('kyc_token'))
	const headers = {
		'Accept': 'application/json',
		'Authorization': 'Bearer ' + tokenData?.access_token,
	}

	return headers
}

export const getcurrentDate = function () {
	const current = new Date()
	const currentMonth = String((current.getMonth() + 1)).padStart(2, '0')
	const currentDay = String(current.getDate()).padStart(2, '0')
	const currentDate = current.getFullYear() + '-' + currentMonth + '-' + currentDay

	return currentDate
}

export const getcurrentDateTime = function () {
	const current = new Date()
	const currentMonth = String((current.getMonth() + 1)).padStart(2, '0')
	const currentDay = String(current.getDate()).padStart(2, '0')
	const currentDateTIme = current.getFullYear() + '-' + currentMonth + '-' + currentDay + ' ' + current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();

	return currentDateTIme
}


export const getUserInfo = function () {
	const loginUserData = JSON.parse(window.localStorage.getItem('auth_user'))
	return loginUserData
}

export const getAppURL = function (appCode) {
	switch (appCode) {
		case 'sas_v2':
			return SAS_SITE;
		case 'vps-v2':
			return VPS_SITE;
		case 'dahongye':
			return DAHONGYE_SITE;
		case 'lng':
			return LNG_SITE;
		case 'pkns':
			return PKNS_SITE;
	}
}
